import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-616d7695"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-form-section" }
const _hoisted_2 = { class: "signup-form-section__title" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import useMediaQuery from '@/composables/common/useMediaQuery'

import SignupForm from '@C/pages/signup/SignupForm/SignupForm.vue'
import AppLogo from '@C/ui/icons/AppLogo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupFormSection',
  setup(__props) {

const { t } = useI18n()

const { isDesktop } = useMediaQuery()

const title = computed(() =>
  isDesktop.value ? t('signupPage.title') : t('signupPage.titleExtendedMobile'),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(AppLogo, { class: "signup-form-section__logo" }),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1),
    _createVNode(SignupForm)
  ]))
}
}

})